'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtLocationEdit', [
	function () {

		return {
			restrict: 'A',
			replace: true,
			scope: {
				place: '=pmtLocationEdit',
				onUpdate: '<',
				saveParentFields: '<',
				openDialog: '=',
				onClose: '&',
				noPartialUpdate: '<',
				onlyAddress: '<',
				onlyServiceArea: '<'
			},
			link: function (scope /*, element, attrs*/) {
				scope.$watch('openDialog', function (newVal, oldVal) {
					if (newVal === oldVal) {
						return;
					} else if (newVal && newVal.toLowerCase() === 'uploadmediareview') {
						scope.openUploadMediaReview = true;
						scope.mediaReviewNetwork = 'google';
					} else {
						let openKey = 'openEdit_' + (newVal || '').toLowerCase();
						scope[openKey] = Date.now();
					}
					scope.openDialog = '';
				});

				scope.close = function () {
					let openKey = 'openEdit_' + scope.openDialog.toLowerCase();
					scope[openKey] = false;
					scope.openDialog = '';
					scope.onClose();
				};
			},
			templateUrl: 'shared/location/edit/pmtLocationEditView.html'
		};
	}
]);
